export const DELETE_SPOT_FAILURE = 'DELETE_SPOT_FAILURE';

export const deleteSpotFailure = (payload: Error) => ({
    type: DELETE_SPOT_FAILURE,
    payload,
    error: true,
});
